import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Input } from '@elevio/elevio-styles/dist/components/hq';

// combination of autosize + webkit-overflow-scrolling results in textarea going blank in mobile
const ObservableTextArea = ({ fieldId, ...rest }) => (
  <Input.TextArea
    key={`TextArea_${fieldId}`}
    id={fieldId}
    autosize={{ minRows: 4, maxRows: 20 }}
    {...rest}
  />
);

ObservableTextArea.propTypes = {
  fieldId: PropTypes.number.isRequired,
};

export default observer(ObservableTextArea);



// WEBPACK FOOTER //
// ./src/components/textarea/index.js